import React, { useState } from 'react';
import * as yup from 'yup';
import { withFormik } from 'formik';
import Grid from '@material-ui/core/Grid';
import axiosWithoutInterceptor from 'axios';
import PaymentSubscription from './PaymentSubscription'
import Input from '../../components/Input/Input';
import { phoneMask, cepMask } from '../../shared/masks';
import Switch from '@material-ui/core/Switch';
import { Typography } from '@material-ui/core';

import Checkbox from '@material-ui/core/Checkbox';

const PaymentByTicket = (props) => {
    const {
        values,
        setState,
        setFormValues,
        companyData,
        handleSubmit,
        handleChange,
        errors,
        touched,
        handleBlur,
        checked,
        planSelected,
        disabledbuttom,
        setDisabledbuttomFormDados,
        creditCards,
        setCreditCards,
        checkbox,
        setCheckbox
    } = props;

    const handleChangeValue = () => {
        if (creditCards) {
            setCreditCards(false);
            setFormValues(values);
        } else {
            setCreditCards(true);
            setFormValues(values);
        }
    };

    function checkErrors() {
        if (errors && Object.keys(errors).length == 0) {
            setDisabledbuttomFormDados(false);
        }
        if (errors && Object.keys(errors).length != 0) {
            setDisabledbuttomFormDados(true);
        }
    }

    function checkInputEmpty() {
        if (companyData.socialName == '') {
            setDisabledbuttomFormDados(true);
        }
        if (companyData.cnpj == '') {
            setDisabledbuttomFormDados(true);
        }
        if (values.phone == '') {
            setDisabledbuttomFormDados(true);
        }
        if (companyData.email == '') {
            setDisabledbuttomFormDados(true);
        }
        if (companyData.cep == '') {
            setDisabledbuttomFormDados(true);
        }
        if (companyData.address == '') {
            setDisabledbuttomFormDados(true);
        }
        if (companyData.addressNumber == '') {
            setDisabledbuttomFormDados(true);
        }
        if (companyData.district == '') {
            setDisabledbuttomFormDados(true);
        }
        if (companyData.city == '') {
            setDisabledbuttomFormDados(true);
        }
        if (companyData.cityCod == '') {
            setDisabledbuttomFormDados(true);
        }
        if (companyData.uf == '') {
            setDisabledbuttomFormDados(true);
        }
        if (values.municipalInscription == '') {
            setDisabledbuttomFormDados(true);
        }
    }

    React.useEffect(() => {
        checkInputEmpty()
    }, [])

    React.useEffect(() => {
        setFormValues(values);
    }, [values])


    const fields = [
        {
            elementType: 'input',
            config: {
                name: 'name',
                label: 'Razão Social',
            },
            required: true,
            autoFocus: true
        },
        {
            elementType: 'maskedInput',
            config: {
                name: 'document',
                label: 'CNPJ',
                mask: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,],
            },
            required: true,
            autoFocus: true
        },
        {
            elementType: 'maskedInput',
            config: {
                name: 'phone',
                label: 'Telefone',
                mask: phoneMask,
            },
            required: true,
            autoFocus: true
        },
        {
            elementType: 'input',
            config: {
                name: 'email',
                label: 'E-mail',
            },
            required: true,
            autoFocus: true
        },
        {
            elementType: 'input',
            config: {
                name: 'municipalInscription',
                label: 'Inscrição Estadual',
                value: 'ISENTO',
            },
            required: checkbox ? false : true,
            disabled: checkbox ? true : false,
            helperText: 'É obrigatorio preencher o campo ou marcar a caixa.',
        },
        {
            elementType: 'maskedInput',
            config: {
                name: 'zipCode',
                label: 'CEP',
                mask: cepMask,
            },
            required: true,
            autoFocus: true,
            helperText: 'Pesquise o endereço pelo CEP',
        },
        {
            elementType: 'input',
            config: {
                name: 'address',
                label: 'Endereço',
            },
            required: true,
            autoFocus: true
        },
        {
            elementType: 'input',
            config: {
                name: 'addressNumber',
                label: 'Número',
            },
            required: true,
            autoFocus: true
        },
        {
            elementType: 'input',
            config: {
                name: 'complement',
                label: 'Complemento',
            },
            required: false,
            autoFocus: true
        },
        {
            elementType: 'input',
            config: {
                name: 'district',
                label: 'Bairro',
            },
            required: true,
            autoFocus: true
        },
        {
            elementType: 'input',
            config: {
                name: 'city',
                label: 'Cidade',
            },
            required: true,
            autoFocus: true
        },
        {
            elementType: 'input',
            config: {
                name: 'state',
                label: 'Estado',
            },
            required: true,
            autoFocus: true
        },
        {
            elementType: 'input',
            config: {
                name: 'ticket',
                label: 'Cupom',
            },
        },
    ];

    React.useEffect(() => {
        if (companyData.cep) {
            fetchCEP(companyData.cep.toString());
        }
    }, []);

    const fetchCEP = (rawCEP) => {
        const cep = rawCEP.replace(/\D+/g, '');
        axiosWithoutInterceptor
            .get(`https://viacep.com.br/ws/${cep}/json/`)
            .then((response) => {
                if (response.data && response.data.erro) {
                    props.setValues({
                        ...values,
                        zipCode: rawCEP,
                        address: '',
                        district: '',
                        city: '',
                        state: '',
                        cityCod: '',
                    });
                } else {
                    props.setValues({
                        ...values,
                        zipCode: rawCEP,
                        address: response.data.logradouro,
                        district: response.data.bairro,
                        city: response.data.localidade,
                        state: response.data.uf,
                        cityCod: response.data.ibge,
                    });
                }
            });
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <Grid container>
                    {
                        fields.map(field => (
                            <Grid item xs={6} style={{ paddingTop: '16px' }}>
                                {field.config.name == 'municipalInscription' ?
                                    <div style={{ display: 'flex', alignItems: 'center', margin: '-13px', marginBottom: '-10px' }}>
                                        <Checkbox
                                            elementType="Checkbox"
                                            checked={checkbox}
                                            onChange={(event) => {
                                                setCheckbox(!checkbox);
                                                handleChange(event);
                                                checkErrors();
                                            }}
                                            name="municipalInscription"
                                            value='ISENTO'
                                            color="primary"
                                        />
                                        <Typography>Declaro ser isento da inscrição estadual / municipal.</Typography>
                                    </div> : ''}
                                <Input
                                    {...field.config}
                                    elementType={field.elementType}
                                    autoFocus={field.autoFocus}
                                    value={values[field.config.name].toString().toUpperCase()}
                                    required={field.required}
                                    disabled={field.disabled}
                                    onChange={(event) => {
                                        handleChange(event);
                                        checkInputEmpty(event.target.name);
                                        checkErrors();
                                        if (event.target.name === 'zipCode' && event.target.value.replace(/\D+/g, '').length === 8) {
                                            fetchCEP(event.target.value);
                                        }
                                    }}
                                    onBlur={(event) => {
                                        checkErrors();
                                        handleBlur(event);
                                    }}
                                    error={errors[field.config.name]}
                                    helperText={
                                        (touched[field.config.name] && errors[field.config.name]) || field.helperText
                                    }
                                    style={{ width: '90%' }}
                                />
                            </Grid>
                        ))
                    }
                </Grid>
            </form>

            <Typography style={{ display: 'flex', justifyContent: 'center', margin: '10px' }}>
                Boleto
                <div style={{ marginTop: '-7px' }}>
                    <Switch
                        checked={creditCards}
                        onChange={handleChangeValue}
                        color="primary"
                        name="checked"
                    />
                </div>
                Cartão
            </Typography>

            <div>
                <PaymentSubscription
                    disabled={disabledbuttom}
                    checkbox={checkbox}
                    values={values}
                    checked={checked}
                    planSelected={planSelected}
                    creditCards={creditCards}
                />
            </div>
        </div>
    );
}

const SubscriptionFormFormik = withFormik({
    mapPropsToValues: ({ cupom, values, companyData, checkbox }) => ({
        name: companyData.socialName || '',
        document: companyData.cnpj || '',
        phone: values.phone || '',
        email: companyData.email || '',
        zipCode: companyData.cep || '',
        address: companyData.address || '',
        addressNumber: companyData.addressNumber || '',
        complement: companyData.complement || '',
        district: companyData.district || '',
        city: companyData.city || '',
        cityCod: companyData.cityCod || '',
        state: companyData.uf || '',
        ticket: cupom || '',
        municipalInscription: values.municipalInscription.trim() || '',
        checkbox: checkbox,
    }),
    validationSchema: yup.object().shape({
        name: yup.string().required(),
        document: yup.string().required(),
        phone: yup.string().strict(false).trim('Informe um formato válido').required(),
        email: yup.string().email().required(),
        zipCode: yup.string().required(),
        address: yup.string().required(),
        addressNumber: yup.string().required(),
        complement: yup.string().required(),
        district: yup.string().required(),
        city: yup.string().required(),
        cityCod: yup.string().required(),
        state: yup.string().required(),
        ticket: yup.string(),
        checkbox: yup.boolean(),
        municipalInscription: yup.lazy(val => (Array.isArray(val) ? yup.array().of(yup.string()) : yup.string().required())),
    }),
})(PaymentByTicket);

export default SubscriptionFormFormik;